
import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { faqs } from '../apiServices/apiServices';
import { toast } from "react-toastify";
import CustomToastContainer from '../components/CustomToastContainer';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';

export default function FAQs() {
  const navigate = useNavigate()
  const [faqsList, setFaqsList] = useState([]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  useEffect(() => {
    const fetchData = async () => {
      await faqsMethods();
    };

    fetchData();
  }, []);

  const faqsMethods = async () => {
    try {
      const response = await faqs();
      // console.log("Faqs API Response:", response);
      if (response && response.success) {
        setFaqsList(response?.data?.faqs);
      } else {
        toast.error(response?.message || 'Something went wrong.');
      }
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error('An error occurred. Please try again.');
    }
  };

  return (
    <div className="bg-gray-100 items-center h-screen">
      {/* <div className="w-full md:w-1/2"> */}
        <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
          <button className="text-gray-600 items-center" onClick={() => handleNavigation(-1)}>
            <FontAwesomeIcon icon={faArrowLeft} size="lg" />
          </button>

          <div className="flex items-center justify-center flex-grow gap-2">
            <h1 className="text-gray-600 font-semibold text-lg">
              FAQS
            </h1>
          </div>
        </nav>       
        <hr/>

        <div className="flex flex-col items-center w-full p-2">
          {faqsList.map((faq) => (
            <Accordion key={faq.id} className="w-full">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${faq.id}-content`}
                id={`panel${faq.id}-header`}
              >
                <Typography className="font-semibold">{faq.title}</Typography>
              </AccordionSummary>
              <AccordionDetails className="text-gray-600">
                <Typography><div dangerouslySetInnerHTML={{__html: faq.answer}} /></Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      {/* </div> */}
      <CustomToastContainer />
    </div>
  );
}
